function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.544-.115l.125.076 10.128 7.036.107.09.082.088.07.088.045.069.06.109.04.088.048.149.03.158.008.081.003.079v7.008l-.003.079-.02.158-.036.14-.03.09-.05.11-.08.135-.085.11-.084.088-.126.105-10.107 7.02a1.168 1.168 0 01-1.215.075l-.123-.075-10.163-7.064-.09-.08-.092-.103-.068-.094-.064-.109-.055-.12-.042-.126-.037-.179-.007-.08-.003-.08V7.996l.003-.081.01-.093.027-.142.038-.118.065-.15.073-.123.028-.04.094-.112.05-.051.142-.117L11.33-.04a1.166 1.166 0 011.214-.076zM6.937 12.994l-2.883 2.008 6.747 4.685v-4.003l-3.864-2.69zm10.124-.001l-3.863 2.691v4.002l6.747-4.684-2.884-2.009zm-5.062-3.528L9.081 11.5l2.918 2.033 2.918-2.034-2.918-2.034zm8.893.86L19.206 11.5l1.686 1.174v-2.349zm-17.785 0v2.349L4.793 11.5l-1.686-1.175zm10.091-7.012v4.002l3.863 2.691 2.884-2.009-6.747-4.684zm-2.397-.001L4.054 7.997l2.883 2.008 3.864-2.69V3.312z",
  fill: "#444",
  fillRule: "evenodd"
});

function SvgIcCodepen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default SvgIcCodepen;